import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  GraphsState,
  Graph,
  GraphsListData,
} from '../../types/graphs.types';

const initialState: GraphsState = {
  graphs: [],
  selectedGraph: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
};

const graphsSlice = createSlice({
  name: 'graphs',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setGraphs: (state, action: PayloadAction<GraphsListData>) => {
      state.graphs = action.payload.graphs;
      state.pagination = {
        ...state.pagination,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalRecords,
        hasMorePages: action.payload.hasMorePages,
      };
      state.loading = false;
      state.error = null;
    },
    setSelectedGraph: (state, action: PayloadAction<Graph | null>) => {
      state.selectedGraph = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pagination.pageSize = action.payload;
    },
    setSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedGraph: (state) => {
      state.selectedGraph = null;
    },
    addGraph: (state, action: PayloadAction<Graph>) => {
      state.graphs.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateGraph: (state, action: PayloadAction<Graph>) => {
      const index = state.graphs.findIndex((g) => g.id === action.payload.id);
      if (index !== -1) {
        state.graphs[index] = action.payload;
      }
      if (state.selectedGraph?.id === action.payload.id) {
        state.selectedGraph = action.payload;
      }
    },
    deleteGraph: (state, action: PayloadAction<string>) => {
      state.graphs = state.graphs.filter((g) => g.id !== action.payload);
      state.pagination.totalRecords -= 1;
      if (state.selectedGraph?.id === action.payload) {
        state.selectedGraph = null;
      }
    },
  },
});

export const {
  setLoading,
  setError,
  setGraphs,
  setSelectedGraph,
  setPage,
  setPageSize,
  setSearch,
  clearError,
  clearSelectedGraph,
  addGraph,
  updateGraph,
  deleteGraph,
} = graphsSlice.actions;

export default graphsSlice.reducer;
